import React from 'react';
import { IContentCalendarSelectedSuggestion } from '../../../../models';
import { isComplianceReviewedContent } from '../../../../models/utils/contentCalendarBulkAiUtils';

/** Defers a single-suggestion AI customize behind a confirmation when the content is compliance-reviewed. */
export function useComplianceReviewedCustomizeGuard() {
	const [pendingCustomize, setPendingCustomize] = React.useState<(() => void) | null>(null);

	const guardCustomize = (suggestion: IContentCalendarSelectedSuggestion, customize: () => void) => {
		if (isComplianceReviewedContent(suggestion)) {
			setPendingCustomize(() => customize);
			return;
		}
		customize();
	};

	return {
		guardCustomize,
		complianceWarningProps: {
			isOpen: pendingCustomize !== null,
			onRequestClose: () => setPendingCustomize(null),
			onConfirm: () => {
				pendingCustomize?.();
				setPendingCustomize(null);
			},
		},
	};
}
